<div id={{dataId}}>
    <ng-container *ngIf="!this.posting">

        <div class="container-fluid px-5" style="border: 1px solid black">
            <div>
                <img [src]="this.logo_url" height="49">
                <h3 style="text-align: center; margin: top 2em;color:#004aad">Medical Record Summary</h3>
            </div>

            <div class="jumbotron" style="background-color: #fff;border: 1px solid black">
                <div class="row">
                    <div class="col-md-6">
                        <h5 style="color:#004aad">Patient Information</h5>
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td style="text-align: left; float: none; font-size: 14px;"><b>Patient Name:</b>
                                    </td>
                                    <td class="text-style" class="notranslate">
                                        {{data.patient.first_name +" "+ (data.patient.middle_name==null?'':data.patient.middle_name) +" "+
                                        data.patient.last_name}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-style"><b>Age:</b></td>
                                    <td class="text-style">{{this.page}}</td>
                                </tr>
                                <tr *ngIf="this.is_gender">
                                    <td class="text-style"><b>Gender:</b></td>
                                    <td class="text-style">{{this.gender}}</td>
                                </tr>
                                <tr>
                                    <td class="text-style"><b>MRN:</b></td>
                                    <td class="text-style">
                                        {{data.patient.medical_record_number}}</td>
                                </tr>
                                <tr>
                                    <td class="text-style"><b>Consultation Date:</b></td>
                                    <td class="text-style">
                                        {{DateFormat(data.consultation.consultation_date)}}</td>
                                </tr>
                                <tr>
                                    <td class="text-style"><b>Consultation Type:</b></td>
                                    <td class="text-style">
                                        {{data.consultation.consultation_type.consultation_name}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-6">
                        <h5 style="color: #004aad;">Doctor Information</h5>
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td class="text-style"><b>Physician Name:</b></td>
                                    <td class="text-style">
                                        {{doctor_name}}
                                    </td>
                                </tr>
                                <tr *ngIf="this.gmc_reg_no">
                                    <td class="text-style"><b>Physician GMC Registration Numbers:</b></td>
                                    <td class="text-style">
                                        {{gmc_reg_no}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-style"><b>Speciality:</b></td>
                                    <td class="text-style">
                                        {{specialty}}</td>
                                </tr>
                                <tr>
                                    <td class="text-style"><b>Date of Issue:</b>&nbsp;</td>
                                    <td class="text-style">
                                        {{DateFormat(data.consultation.consultation_closed_date)}}</td>
                                </tr>
                                <tr>
                                    <td class="text-style"><b>Request No:</b></td>
                                    <td class="text-style">
                                        {{data.consultation.consultation_request_number}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="col-md-12">
                        <h5 style="color:#004aad">Patient Health Data</h5>
                        <table class="table">
                            <tbody>
                                <ng-container *ngIf="this.isNutritionAndHealthConsultation()">
                                    <tr *ngIf="this.is_diet_prefernce">
                                        <td class="text-style"><b>Diet Preference</b></td>
                                        <td class="text-style WordWrap format-lines">
                                            {{this.data.consultation.diet_consultation_data.final_diet_preference}}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="text-style"><b>Diet Health Goal</b></td>
                                        <td class="text-style WordWrap format-lines">
                                            {{this.data.consultation.diet_consultation_data.health_goal}}
                                        </td>
                                    </tr>
                                </ng-container>

                                <tr>
                                    <td class="text-style"><b>Past Medical History</b></td>
                                    <td class="text-style WordWrap format-lines">
                                        {{this.past_medical_history_data}}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="text-style"><b>Past Surgical History</b></td>
                                    <td class="text-style WordWrap format-lines">
                                        {{this.past_medical_surgical_history}}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="text-style"><b>Medications</b></td>
                                    <td class="text-style WordWrap format-lines">
                                        {{this.medication_data}}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="text-style"><b>Allergies</b></td>
                                    <td class="text-style WordWrap format-lines">
                                        {{this.allergy_data}}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="text-style"><b>Social History</b></td>
                                    <td class="text-style WordWrap format-lines">
                                        {{this.social_history_data}}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="text-style"><b>Family History</b></td>
                                    <td class="text-style WordWrap format-lines">
                                        {{this.family_history_data}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                    <div class="col-md-12">
                        <h5 style="color:#004aad">Consultation Data</h5>
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td class="text-style"><b>Chief Complaint/Medical Issues</b></td>
                                    <td class="text-style WordWrap format-lines">{{this.condition_description}}</td>
                                </tr>

                                <tr>
                                    <td class="text-style"><b>History of current illness</b></td>
                                    <td class="text-style WordWrap format-lines">
                                        {{this.history_of_current_illness}}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="text-style"><b>Consultation Notes</b></td>
                                    <td class="text-style WordWrap format-lines">
                                        {{this.consultation_notes}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </div>

                <!-- <div class="row">
                    <div class="col-md-12">
                        <h5 class="doctorReport_header">Chief Complaint/Medical Issues</h5>
                        <p class="doctorReport_content WordWrap format-lines">{{this.condition_description}}</p>
                        <hr>
                    </div>

                    <ng-container *ngIf="this.isNutritionAndHealthConsultation()">

                        <div class="col-md-12" *ngIf="this.is_diet_prefernce">
                            <h5 class="doctorReport_header">Diet Preference</h5>
                            <p class="doctorReport_content WordWrap format-lines">
                                {{this.data.consultation.diet_consultation_data.final_diet_preference}}
                            </p>
                            <hr>
                        </div>

                        <div class="col-md-12">
                            <h5 class="doctorReport_header">Diet Health Goal</h5>
                            <p class="doctorReport_content WordWrap format-lines">
                                {{this.data.consultation.diet_consultation_data.health_goal}}
                            </p>
                            <hr>
                        </div>

                    </ng-container>

                    <div class="col-md-12">
                        <h5 class="doctorReport_header">History of current illness</h5>
                        <p class="doctorReport_content WordWrap format-lines">{{this.history_of_current_illness}}</p>
                        <hr>
                    </div>

                    <div class="col-md-12">
                        <h5 class="doctorReport_header">Past Medical History</h5>
                        <p class="doctorReport_content WordWrap format-lines">{{this.past_medical_history_data}}</p>
                        <hr>
                    </div>

                    <div class="col-md-12">
                        <h5 class="doctorReport_header">Past Surgical History</h5>
                        <p class="doctorReport_content WordWrap format-lines">{{this.past_medical_surgical_history}}</p>
                        <hr>
                    </div>

                    <div class="col-md-12">
                        <h5 class="doctorReport_header">Medications</h5>
                        <p class="doctorReport_content WordWrap format-lines">{{this.medication_data}}</p>
                        <hr>
                    </div>

                    <div class="col-md-12">
                        <h5 class="doctorReport_header">Allergies</h5>
                        <p class="doctorReport_content WordWrap format-lines">{{this.allergy_data}}</p>
                        <hr>
                    </div>

                    <div class="col-md-12">
                        <h5 class="doctorReport_header">Social History</h5>
                        <p class="doctorReport_content WordWrap format-lines">{{this.social_history_data}}</p>
                        <hr>
                    </div>

                    <div class="col-md-12">
                        <h5 class="doctorReport_header">Family History</h5>
                        <p class="doctorReport_content WordWrap format-lines">{{this.family_history_data}}</p>
                        <hr>
                    </div>

                    <div class="col-md-12">
                        <h5 class="doctorReport_header">Consultation Notes</h5>
                        <p class="doctorReport_content WordWrap format-lines">{{this.consultation_notes}}</p>
                        <hr>
                    </div>

                </div> -->
                <div class="row" *ngIf=" this.isapollodiagnosticsline == true && this.apolloDiagnosticsCoupon !=null"
                    style="justify-content: center;">
                    <h5>Use code<b style="padding-left: 5px !important;">{{this.apolloDiagnosticsCoupon}}</b> to get 15%
                        off on diagnostic tests at Apollo Diagnostics <a href="https://www.apollodiagnostics.in"
                            target='_blank'>(https://www.apollodiagnostics.in)</a></h5>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-12">
                    <table>
                        <tbody>
                            <div class="col-md-12">
                                <!-- <tr *ngIf="this.is_signature"> -->
                                <tr>
                                    <td rowspan="2">
                                        <p style="text-align: left; color:#004aad;">Electronically Signed and verified
                                            by: </p>
                                    </td>
                                    <td style="text-align: left;font-weight: bold;" *ngIf="show_signature">
                                        <img [src]="data.signature_url" alt="signature"
                                            style="height: 100px; border: 1px solid black;  margin-bottom: 3%; text-align: center;">
                                    </td>
                                    <td style="text-align: left;font-weight: bold;">
                                        {{data.consultation.egd_users.first_name +" "+
                                        (data.consultation.egd_users.middle_name==null?'':data.consultation.egd_users.middle_name)
                                        +" "+
                                        data.consultation.egd_users.last_name}}
                                    </td>
                                </tr>
                            </div>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-12">
                <hr>
                <p style="text-align: right; float: left;" *ngIf="this.is_primary_provider && !is_uk_country">www.eglobaldoctors.com</p>
                <p style="text-align: right; float: left;" *ngIf="this.is_primary_provider && is_uk_country">www.eglobaldoctors.co.uk</p>
                <p style="text-align: right;">{{DateFormat(data.consultation.created_at)}}</p>
            </div>
        </div> <!-- /container -->
    </ng-container>


    <h4 *ngIf="this.posting">Fetching data...</h4>
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="this.posting" strokeWidth="6">
    </p-progressSpinner>
</div>